import * as React from "react";
import "./LoginPage.css";
import { RouteChildrenProps } from "react-router";
import { Link } from "react-router-dom";
import { Form, Button, Alert } from "react-bootstrap";
import firebase from "../firebase";
import { storage } from "firebase";
import { tryGetDownloadUrl } from "../storage";

const TORISETSU = "http://ai-quest.jp/AQ-Scope-Soil-instruction-manual.pdf"
const USERSMANUAL = "http://ai-quest.jp/AQ-Scope-Soil-users-manual.pdf"

interface LoginPageState {
    email: string;
    password: string;
    errorMessage: string;
}

export default class LoginPage extends React.Component<RouteChildrenProps, LoginPageState> {
    private onClickLoginBound: (ev: React.MouseEvent) => void;
    private onChangeEmailBound: (ev: React.FormEvent<any>) => void;
    private onChangePasswordBound: (ev: React.FormEvent<any>) => void;

    constructor(props: RouteChildrenProps) {
        super(props);
        this.onClickLoginBound = this.onClickLogin.bind(this);
        this.onChangeEmailBound = this.onChangeEmail.bind(this);
        this.onChangePasswordBound = this.onChangePassword.bind(this);

        this.state = {
            email: "",
            password: "",
            errorMessage: ""
        }
    }

    async onClickLogin(ev: React.MouseEvent): Promise<void> {
        ev.preventDefault();
        const {email, password} = this.state;
        try {
            await firebase.auth().signInWithEmailAndPassword(email, password);
        } catch (e) {
            this.setState({errorMessage: e.message});
        }
    }

    onChangeEmail(ev: React.FormEvent<any>): void {
        const value: string = (ev.target as HTMLInputElement).value;
        this.setState({email: value});
    }

    onChangePassword(ev: React.FormEvent<any>): void {
        const value: string = (ev.target as HTMLInputElement).value;
        this.setState({password: value});
    }

    render() {
        const alert = this.state.errorMessage ? (<Alert variant="danger">{this.state.errorMessage}</Alert>) : null;

        return (
            <div className="login-box">
                <div className="login-box-body">
                    <p className="text-center">
                        <h1>AQ Soil ログイン</h1>
                    </p>
                    <Form>
                        <Form.Group controlId="formBasicEmail">
                            <Form.Label>メールアドレス</Form.Label>
                            <Form.Control type="email" placeholder="Enter email" value={this.state.email} onChange={this.onChangeEmailBound}/>
                        </Form.Group>

                        <Form.Group controlId="formBasicPassword">
                            <Form.Label>パスワード</Form.Label>
                            <Form.Control type="password" placeholder="Password" value={this.state.password} onChange={this.onChangePasswordBound} />
                        </Form.Group>
                        {alert}
                        <p className="text-center">
                            <Button variant="primary" type="submit" onClick={this.onClickLoginBound}>
                                ログイン
                            </Button>
                        </p>
                        <p className="text-right">
                            <Button variant="link" type="button" onClick={async () => {
                                 window.open(TORISETSU, "_blank")
                                 }}>
                                取扱説明書
                            </Button>
                        </p>
                        <p className="text-right">
                            <Button variant="link" type="button" onClick={async () => {
                                 window.open(USERSMANUAL, "_blank")
                                 }}>
                                マニュアル
                            </Button>
                        </p>
                    </Form>
                </div>
            </div>
        );
    }
}
